export enum TableColumnTypeEnum {
  DEFAULT,
  CHECKBOX,
  ACTIONS,
  STATUS,
  LOADING,
}
